import React, { useEffect, useState } from 'react'
import { Avatar, Button, Card, Col, Icons, Row } from '@pankod/refine-antd'

import { useTranslate, useGetIdentity, useList, useTable } from '@pankod/refine-core'

import './style.less'

import { IPaper, IPaperRequest, IQuestion, ITestEvent } from 'interfaces'
import dayjs, { Dayjs } from 'dayjs'
import {
  getWorkRequestCount,
  getQuestionCount,
  getPaperCount,
  getPaperRequestCount,
  getPaperTemplateCount,
  getEvaluationRequestDetailsByUser,
  getEvaluationRequestDetailsByUserStatus,
} from 'gql/query'
import { useUserContext } from 'context/user'
// import DashBoardChart from 'components/chart/Chart'
const { QuestionOutlined, ExceptionOutlined, ProjectOutlined, LikeOutlined, UserOutlined, RightCircleOutlined } = Icons

const { Meta } = Card

export const EvaluationDashboard: React.FC = () => {
  const { data: user } = useGetIdentity()
  console.log({ user })
    const { changeUser, userRole } = useUserContext()
    const [total, setTotal] = useState(0)
     const [completd, setCompleted] = useState(0)
  useEffect(() => {
    getEvaluationRequestDetailsByUser(user?.id, userRole).then((resp: any) => {
        // console.log({ resp })
        setTotal(resp?.evaluation_requests_aggregate?.aggregate?.count)
    })
      getEvaluationRequestDetailsByUserStatus(user?.id, userRole).then((resp: any) => {
        // console.log({ resp })
        setCompleted(resp?.evaluation_requests_aggregate?.aggregate?.count)
    })
  }, [userRole, user])
  return (
    <div className="">
      <>
        <Row gutter={16} className="mt-3">
          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4>Evaluation Requests</h4>
                  <h3 style={{ margin: '0' }}>{total}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <ProjectOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>
          <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
            <div className="dashboard-card1">
              <Row className="card-content">
                <Col md={18} className="text-container">
                  <h4> Completed Requests </h4>
                  <h3 style={{ margin: '0' }}>{completd}</h3>
                </Col>
                <Col md={6} className="icon-container">
                  <ProjectOutlined className="icon" />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </>
     
      {/* {breakpoint.md&&<div style={{marginTop:'5rem'}}>
      <DashBoardChart details={details} label={label} />
      </div>} */}
     
    </div>
  )
}
